module.exports = __webpack_public_path__ + "media/images/application/template/SAF-email-footer-2f996349985ccd057da0cf4ee50f44b7.png";